import { localText, registerClass } from "@serenity-is/corelib";
import { AddonTextWithIcon } from "./AddonTextWithIcon";
import { EditorAddonUtils } from "./EditorAddonUtils";

export function InputGroupButtonAddon(props: {
    addonKey?: string,
    text?: string,
    before?: boolean,
    hint?: string,
    icon?: string,
    buttonClass?: string,
    cssClass?: string,
    editorElement?: HTMLElement
}): HTMLElement {
    const { addonKey, buttonClass, cssClass, hint, icon, text, editorElement, before } = props;
    const btnClass = buttonClass?.startsWith("btn-") ? buttonClass : ("btn-" + (buttonClass ?? "addon-default"));

    const addon = (
        <button type="button" class={["btn btn-addon", btnClass, cssClass]} title={!!hint && localText(hint, hint)}
            data-addonkey={!!addonKey && addonKey} data-addonfor={editorElement?.id}>
                
            <AddonTextWithIcon text={text} icon={icon} />
        </button>
    ) as HTMLElement;

    EditorAddonUtils.appendToInputGroup(editorElement, addon, before);
    return addon;
}

registerClass(InputGroupButtonAddon, 'Serenity.InputGroupButtonAddon');
